import { Outlet } from "react-router-dom";
import React from "react";
import { useAppDispatch } from "@src/integrations/redux/redux-store";
import { authStorage } from "@src/features/auth/auth-storage";
import { setAuthState } from "@src/features/auth/redux/auth-slice";

export function AuthLoaderLayout() {
	const dispatch = useAppDispatch();
	const [isLoaded, setIsLoaded] = React.useState(false);

	React.useEffect(() => {
	  const authState = authStorage.loadAuthState();
	  if (authState) {
		  // We don't handle clearing the state, just it's initial loading
		dispatch(setAuthState(authState));
	  }
      setIsLoaded(true);
	}, []);

	if (!isLoaded) return 
	<p>
		Loading...
	</p>;

	return <Outlet />;
}